import React from 'react';
import PropTypes from 'prop-types';
import { getColor } from 'core/utils/Styles';

const ShopBag = ({ stroke, ...props }) => (
	<svg width="1em" height="1em" viewBox="0 0 22 22" {...props}>
		<title>ShopBag</title>
		<g fill="none" stroke={stroke}>
			<path d="M20.394 17.863A2.855 2.855 0 0 1 17.55 21H3.856a2.856 2.856 0 0 1-2.842-3.137L2.133 6.535h17.142l1.119 11.328z" />
			<path d="M6.418 9.572V5.286a4.286 4.286 0 0 1 8.571 0v4.286" />
		</g>
	</svg>
);

ShopBag.propTypes = {
	width: PropTypes.number,
	height: PropTypes.number,
	stroke: PropTypes.string,
	strokeWidth: PropTypes.number,
};

ShopBag.defaultProps = {
	width: 22,
	height: 22,
	stroke: getColor('dustyGray'),
	strokeWidth: 2,
};

export default ShopBag;
